import { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { useHistory } from "react-router-dom";

import Sidebar from './components/Sidebar';
import Topbar from './components/Topbar';

import UniqueDiscountCodeCard from '../../admin/components/setting/UniqueDiscountCodeCard';
import GeneralDiscountCodeCard from '../../admin/components/setting/GeneralDiscountCodeCard';

const DiscountCode = ({ token, distributor }) => {

    const history = useHistory();

    const [toggled, setToggled] = useState(false);

    useEffect(() => {
        if (!distributor || !distributor.discount_code) {
            history.push('/distributor')
        }
    }, [])

    const handleToggle = () => {
        setToggled(!toggled);
    }

    return (
        <div className="admin-page-container">
            <Sidebar toggled={toggled} setToggled={handleToggle} />

            <div className="admin-page">
                <Topbar handleToggle={handleToggle} />

                <div className="admin-content">
                    <GeneralDiscountCodeCard id={distributor?.distributorId} role="distributor" token={token} country={distributor?.country} outlets={distributor?.outlet} />
                    <UniqueDiscountCodeCard id={distributor?.distributorId} role="distributor" token={token} country={distributor?.country} outlets={distributor?.outlet} />
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = state => {
    return {
        distributor: state.distributor.distributor,
        token: state.distributor.token
    };
};

export default connect(mapStateToProps, null)(DiscountCode);